"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderActionTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OrderActionTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    date: typebox_1.Type.String(),
    driverProfileId: typebox_1.Type.String(),
    driverSnapshot: typebox_1.Type.Unknown(),
    notes: typebox_1.Type.String(),
});
//# sourceMappingURL=order-action-transport.js.map